import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ theme, displayState }) => css`
    max-width: ${displayState?.maxWidth ?? '250px'};
    min-width: ${displayState?.minWidth ?? ''};
    width: ${displayState?.width ? displayState?.width : "200px"};
    position: absolute;
    padding-inline: ${displayState?.paddingX ? displayState?.paddingX : "10px"};
    padding-block: ${displayState?.paddingY ? displayState?.paddingY : "10px"};
    top: ${`calc(50% +  ${displayState?.topTransform ?? '0px'})`};
    z-index: 10;
    left: calc(100% + 8px);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    background: ${displayState?.background ?? `${theme?.colour?.secondary}E6`};
    color: white;
    font-size: 12px;
    white-space: pre-wrap;
    border-radius: 8px;

    ${displayState?.position === 'left' && css`
      left: -8px;
      transform: translate(-100%, -50%);
    `}
    ${displayState?.position === 'left-top' && css`
      left: -8px;
      transform: translate(-100%, -100%);
    `}
    ${displayState?.position === 'left-bottom' && css`
      left: -8px;
      transform: translate(-100%, 0%);
    `}
    ${displayState?.position === 'top' && css`
      top: -8px;
      transform: translate(-50%, ${displayState?.topTransform ?? '-20px'});
      left: 50%;
    `}
    ${displayState?.position === 'bottom' && css`
      top: 0;
      left: 0;
      transform: translate(${displayState?.bottomTransform ?? '-40%'},  ${displayState?.topTransform ?? '20px'});
    `}
  `}
`;

export default Wrapper(template);